import React from "react";
import { Button, FormControlLabel, Switch, Alert } from "@mui/material";
import UserList from "../../../../components/UserList";
import { COLORS } from "../../../../utils/colors";
import EmptyState from "../../../EmptyStates/EmptyState";
import { getDuplicateMerchantUserEmails } from "../../../../utils/merchantUserStaffOptions";

const MerchantUsers = ({
  merchant,
  merchantUsers,
  setModalTitle,
  setModalContent,
  handleDisplayModal,
  includeInactiveUsers,
  setIncludeInactiveUsers,
}) => {
  const duplicateEmails = getDuplicateMerchantUserEmails(merchantUsers);
  const duplicateCount = merchantUsers.filter((user) =>
    duplicateEmails.has((user.email || "").trim().toLowerCase())
  ).length;
  const inactiveCount = merchantUsers.filter((user) => user.active === false).length;
  const activeCount = merchantUsers.length - inactiveCount;

  const AddMerchantUser = () => (
    <Button
      sx={{ backgroundColor: COLORS.priorityBlue.hex }}
      variant="contained"
      onClick={() => {
        setModalTitle("Add Merchant User");
        setModalContent("addMerchantUser");
        handleDisplayModal(true);
      }}
    >
      Add New User
    </Button>
  );

  return merchantUsers.length === 0 ? (
    <div className="w-full flex flex-column gap-4 py-8">
      <div className="flex flex-row w-full items-center justify-between gap-4">
        <AddMerchantUser />
        <FormControlLabel
          control={
            <Switch
              checked={includeInactiveUsers}
              onChange={(e) => setIncludeInactiveUsers(e.target.checked)}
              color="primary"
            />
          }
          label={includeInactiveUsers ? "Hide inactive users" : "Show inactive users"}
        />
      </div>
      <div className="w-full flex justify-center">
        <EmptyState
          type="merchantUsers"
          text={
            includeInactiveUsers
              ? "No merchant users for this account."
              : "No active merchant users. Use the toggle above to include inactive accounts and check for duplicates."
          }
          action={<AddMerchantUser />}
        />
      </div>
    </div>
  ) : (
    <div className="mt-4 flex flex-column gap-4">
      <div className="flex flex-row flex-wrap w-full items-center justify-between gap-4">
        <AddMerchantUser />
        <FormControlLabel
          control={
            <Switch
              checked={includeInactiveUsers}
              onChange={(e) => setIncludeInactiveUsers(e.target.checked)}
              color="primary"
            />
          }
          label={includeInactiveUsers ? "Hide inactive users" : "Show inactive users"}
        />
      </div>
      {merchantUsers.length > 0 && (
        <p className="text-sm text-gray-600">
          {activeCount} active{inactiveCount > 0 ? `, ${inactiveCount} inactive` : ""}
          {!includeInactiveUsers && inactiveCount > 0 ? " (hidden)" : ""}
        </p>
      )}
      {includeInactiveUsers && duplicateCount > 0 && (
        <Alert severity="warning">
          {duplicateCount} user record{duplicateCount === 1 ? "" : "s"} share duplicate emails on this
          account. Inactive duplicates can break store staff assignments — remove or reactivate the
          correct record.
        </Alert>
      )}
      <UserList userList={merchantUsers} merchant={merchant} duplicateEmails={duplicateEmails} />
    </div>
  );
};
export default MerchantUsers;
